import { customerMarketShopfrontApi, Site } from '@envato/foundation-types'
import { connect, Dispatch } from 'react-redux'
import { RouteConfigComponentProps } from 'react-router-config'

import { closeModal, openModal } from '../../common/actions/layout'

import { IRootState } from '../../common/reducers'
import { IPageSeoMeta } from '../../typings/seoMetadata'
import App from '../pages'

interface IOwnProps extends RouteConfigComponentProps<any> {
  location: any // TODO: REMOVE THIS WHEN LOCATION IS NOT ADDING QUERY
}

interface IStateProps {
  baseUrl: string
  currentSite: Site
  errorPage: any
  isModalOpen: boolean
  noIndex: boolean
  openModalData: any
  openModalType: any
  seoMeta: IPageSeoMeta
  stats: customerMarketShopfrontApi.stats.IResult | null
  canonicalPath: string
}

interface IDispatchProps {
  closeModal: () => any
  openModal: (data: any) => any
}

const mapStateToProps = (state: IRootState): IStateProps => {
  const { layout, common } = state
  const {
    baseUrl,
    currentSite,
    errorPage,
    noIndex,
    seoMeta,
    stats,
    canonicalPath
  } = common
  const { isModalOpen, openModalType, openModalData } = layout

  return {
    baseUrl,
    currentSite,
    errorPage,
    isModalOpen,
    noIndex,
    openModalData,
    openModalType,
    seoMeta,
    stats,
    canonicalPath
  }
}

const mapDispatchToProps = (dispatch: Dispatch<IRootState>): IDispatchProps => {
  return {
    closeModal: () => dispatch(closeModal()),
    openModal: (data: any) => dispatch(openModal(data))
  }
}

export type Props = IOwnProps & IDispatchProps & IStateProps

const createAppContainer = (component: React.ComponentType<Props>) => {
  return connect<IStateProps, IDispatchProps, IOwnProps, IRootState>(
    mapStateToProps,
    mapDispatchToProps
  )(component)
}

export default createAppContainer(App)
